import axios from 'Src/helpers/api/axiosInstance';

export function register(data) {
  return axios.post(`${window.apiBase}/i/register`, data).then(response => {
    const payload = response.data;

    if (payload?.isError) {
      return Promise.reject({ response: { data: payload } });
    }

    return payload;
  });
}
